import { createRouter, createWebHistory } from 'vue-router';
import axios from 'axios';

import HomePage from '@/views/HomePage.vue';
import Shop from '@/views/Shop.vue';
import Checkout from '@/views/Checkout.vue';
import CheckoutSuccess from '@/views/CheckoutSuccess.vue';
import Orders from '@/views/Orders.vue';
import RegisterUser from '@/views/RegisterUser.vue';
import LoginUser from '@/views/LoginUser.vue';
import RegisterUserSuccessful from '@/views/RegisterUserSuccessful.vue';
import VerifyEmail from '@/views/VerifyEmail.vue';
import EmailVerified from '@/views/EmailVerified.vue';
import RequestPasswordReset from '@/views/RequestPasswordReset.vue';
import RequestPasswordResetSuccessful from '@/views/RequestPasswordResetSuccessful.vue';
import ResetPassword from '@/views/ResetPassword.vue';
import ResetPasswordSuccessful from '@/views/ResetPasswordSuccessful.vue';
import NotFound from '@/views/NotFound.vue';
import RetailerInviteAccept from '@/views/RetailerInviteAccept.vue';
import RetailTerms from '@/views/RetailTerms.vue';
import MarketingPage from '@/views/MarketingPage.vue';
import { marketingManifest, marketingRoutes } from '@/content/marketingManifest';

const marketingPageRoutes = marketingRoutes.map((path) => {
  const page = marketingManifest[path];
  return {
    path,
    name: `Marketing-${page.slug}`,
    component: MarketingPage,
    props: { pagePath: path },
    alias: [`/${page.source}`],
    meta: { title: page.title, requiresAuth: false },
  };
});

const routes = [
  { path: '/', name: 'HomePage', component: HomePage, meta: { title: 'Home | UCARI' } },
  { path: '/login', name: 'LoginUser', component: LoginUser, meta: { requiresAuth: false } },
  { path: '/register', name: 'RegisterUser', component: RegisterUser, alias: '/retailer', meta: { requiresAuth: false } },  
  { path: '/registration-successful', name: 'RegisterUserSuccessful', component: RegisterUserSuccessful, meta: { requiresAuth: false } },  
  { path: '/verify-email', name: 'VerifyEmail', component: VerifyEmail, meta: { requiresAuth: false } },  
  { path: '/email-verified', name: 'EmailVerified', component: EmailVerified, meta: { requiresAuth: false } },  
  { path: '/request-password-reset', name: 'RequestPasswordReset', component: RequestPasswordReset, meta: { requiresAuth: false } },
  { path: '/request-password-reset-successful', name: 'RequestPasswordResetSuccessful', component: RequestPasswordResetSuccessful, meta: { requiresAuth: false } },
  { path: '/reset-password', name: 'ResetPassword', component: ResetPassword, meta: { requiresAuth: false } },
  { path: '/reset-password-successful', name: 'ResetPasswordSuccessful', component: ResetPasswordSuccessful, meta: { requiresAuth: false } },
  { path: '/retailers/accept', name: 'RetailerInviteAccept', component: RetailerInviteAccept, meta: { requiresAuth: false, title: 'Accept Retailer Invite | UCARI' } },

  { path: '/shop', name: 'Shop', component: Shop, meta: { title: 'Shop | UCARI', requiresAuth: true } },
  { path: '/checkout', name: 'Checkout', component: Checkout, meta: { title: 'Checkout | UCARI', requiresAuth: true } },
  { path: '/checkout/success', name: 'CheckoutSuccess', component: CheckoutSuccess, meta: { title: 'Checkout Success | UCARI', requiresAuth: true } },
  { path: '/orders', name: 'Orders', component: Orders, meta: { title: 'Orders | UCARI', requiresAuth: true } },
  { path: '/retail-terms', name: 'RetailTerms', component: RetailTerms, meta: { requiresAuth: false, title: 'Retail Sales & Pricing | UCARI' } },

  { path: '/retailer-portal', redirect: { name: 'LoginUser' }, alias: '/retailer-portal.html' },
  { path: '/events', redirect: { name: 'HomePage' } },
  ...marketingPageRoutes,
  
  {
    path: '/logout',
    name: 'Logout',
    async beforeEnter(to, from, next) {
      try {
        await axios.post(`${process.env.VUE_APP_API_URL}/api/logout`, {}, { withCredentials: true });
      } catch {
        //
      }
      localStorage.removeItem('accessToken');
      localStorage.removeItem('cid');
      localStorage.removeItem('squareCustomerId');
      localStorage.removeItem('userEmail');
      next({ name: 'LoginUser' });
    }
  },

  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) return { el: to.hash, behavior: 'smooth' };
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta?.title) document.title = to.meta.title;

  const token = localStorage.getItem('accessToken'); // <-- correct key

  // If a protected route and no token, go to login with redirect back
  if (to.meta?.requiresAuth && !token) {
    return next({ name: 'LoginUser', query: { redirect: to.fullPath } });
  }

  next();
});

export default router;
